import { useState } from 'react';
import { colors, modal as S, btn } from './styles';

/**
 * DeleteVideo
 * Props:
 *   video          - the video object to delete
 *   onConfirm(id)  - async fn that DELETEs the video; throws on error
 *   onClose()      - closes the modal
 */
export default function DeleteVideo({ video, onConfirm, onClose }) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError]       = useState('');

  const handleConfirm = async () => {
    setDeleting(true);
    setError('');
    try {
      await onConfirm(video.id);
      onClose();
    } catch (e) {
      setError('Delete failed: ' + e.message);
      setDeleting(false);
    }
  };

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div
        style={{ ...S.confirmBox }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
          Delete video?
        </div>
        <div style={{ fontSize: 14, color: colors.textMuted, lineHeight: 1.6, marginBottom: '1.25rem' }}>
          This will permanently delete <strong>{video.title}</strong> along with all its tags and chapters. This cannot be undone.
        </div>

        {error && (
          <div style={{
            background: colors.dangerBg, color: colors.danger,
            border: `0.5px solid ${colors.dangerBorder}`, borderRadius: 8,
            padding: '9px 13px', fontSize: 13, marginBottom: 12,
          }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={onClose}
            style={{ ...btn.base, ...btn.ghost }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={deleting}
            style={{ ...btn.base, ...btn.danger, opacity: deleting ? 0.5 : 1 }}
          >
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
